
<template>
  <CSidebar
    position="fixed"
    class="custom-sidebar"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="(event) =>
      $store.commit({
        type: 'updateSidebarVisible',
        value: event,
      })"
  >
    <CSidebarBrand class="sidebar-brand-aligned">
      <img
        class="sidebar-brand-narrow"
        :src="RoybavalLogo"
        alt="Roybaval Logo"
        height="35"
      />
      <h2 class="styled-heading">ROYBAVAL</h2>
      <img
        :src="folder"
        v-if="!sidebarUnfoldable"
        class="icon-sidebar-toggler d-none d-lg-flex" 
        icon="cilExpandRight" 
        @click="$store.commit('toggleUnfoldable')" 

      />
      <img
        :src="unfolder"
        v-if="sidebarUnfoldable" 
        class="icon-sidebar-toggler d-none d-lg-flex" 
        icon="cilExpandRight" 
        @click="$store.commit('toggleUnfoldable')" 
      />
    </CSidebarBrand>
    

    <div class="sidebar-content">
      <CRow>
        <CCol sm="9" class="d-flex align-items-center input-toggler">
          <CButton @click="openModal" color="light" class="d-flex gap-2 align-items-center mx-1 input-search-bar">  <CIcon :icon="cilSearch" style="color: #515050 !important;" />
            Buscar...
          </CButton>

          <!--<CInputGroup class="search-query-menu input-toggler">
            <CInputGroupText style="color: #515050 !important;background: transparent;" >
              <CIcon :icon="cilSearch" style="color: #515050 !important;" />
            </CInputGroupText>
            <CFormInput placeholder="Buscar..." @focus="openModalopenModal" class="input-search" aria-label="Username" aria-describedby="basic-addon1"/>
          </CInputGroup>-->
        </CCol>
        <CCol sm="2" class="d-flex my-2">
          <CButton 
            color="light"
          >
            <CIcon icon="cilPlus" />
          </CButton>
        </CCol>
      </CRow> 
      <AppSidebarNav :search-query="searchQuery"/>
    </div>
    <CSidebarFooter>
      <div style="cursor: pointer;" >
        <CAvatar @click="$router.push('/setting')" :src="baseURL+user.image" size="md" />
        {{user?.first_name+' '+user?.last_name }}
        <CIcon icon="cil-account-logout"  @click="logout" style="margin-left: 35px;"  />
      </div>
      <!--<CSidebarToggler
        class="d-none d-lg-flex"
        @click="$store.commit('toggleUnfoldable')"
      />-->
    </CSidebarFooter>
    <ModalSearch @close="isOpenModalSearch = false" :isOpenModalSearch="isOpenModalSearch" ></ModalSearch>
  </CSidebar>
</template>

<script>
import RoybavalLogo from "@/assets/brand/RoybavalLogo.png";
import folder from "@/assets/icons/folder.svg";
import unfolder from "@/assets/icons/unfolder.svg";
import { computed } from "vue";
import { useStore } from "vuex";
import { AppSidebarNav } from "./AppSidebarNav";
import { logoNegative } from "@/assets/brand/logo-negative";
import { sygnet } from "@/assets/brand/sygnet";
import { cilPeople, cilSearch } from "@coreui/icons";
import { useUserStore } from "@/plugins/store";
import axios from "axios";
import ModalSearch from './ModalSearch';

export default {
  name: "AppSidebar",
  components: {
    AppSidebarNav,
    ModalSearch
  },
  data() {
    return {
      baseURL: axios.defaults.baseURL,
      searchQuery: null,
      isOpenModalSearch: false
    };
  },
  setup() {
    const userStore = useUserStore();
    const user = userStore.getUser;
    const store = useStore();
    return {
      userStore,
      RoybavalLogo,
      folder,
      unfolder,
      user,
      cilPeople,
      logoNegative,
      cilSearch,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    };
  },
  mounted() {
  
  },
  methods: {
    logout(){
      this.userStore.logout()
      .finally(() => {
        location.href= '#/pages/login'
      })
    },
    openModal(){
      this.isOpenModalSearch = true
    },
    toggleSidebar() {
      // 1. Obtiene el estado actual de sidebarUnfoldable del Vuex Store
      const currentState = this.$store.state.sidebarUnfoldable;

      // 2. Invierte el valor (true -> false, false -> true)
      const newValue = !currentState;

      // 3. Usa la mutación para actualizar el estado
      this.$store.commit({
        type: 'updateSidebarUnfoldable', // Asegúrate de que esta mutación existe en tu Store
        value: newValue,
      });
    },
  },
};
</script>

<style scoped>
  /* Asegura que el sidebar mantenga su comportamiento original */
  .custom-sidebar {
    height: 100vh; /* Ocupar toda la ventana del navegador */
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Evitar que el scroll afecte el diseño principal */
    transition: width 0.3s; /* Suaviza el cambio al colapsar/desplegar */
    background: #000;
  }

  /* Estilo personalizado para alinear la marca */
  .sidebar-brand-aligned {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap; /* Permite que los elementos se reorganicen en pantallas más pequeñas */
    gap: 10px; /* Espacio entre el texto y el logo */
  }

  /* Contenido desplazable */
  .sidebar-content {
    flex: 1;
    overflow-y: auto; /* Activa scroll para contenido interno */
    padding: 0.5rem; /* Opcional, ajusta margen interno */
    overflow-x: hidden;
  }

  /* Scroll personalizado */
  .sidebar-content {
    scrollbar-width: thin;
    scrollbar-color: #4a5690 transparent;
  }

  .sidebar-content::-webkit-scrollbar {
    width: 8px;
  }

  .sidebar-content::-webkit-scrollbar-track {
    background: transparent;
  }

  .sidebar-content::-webkit-scrollbar-thumb {
    background: linear-gradient(90deg, #1FD4B5, #22C4B7, #23B0B9);
    border-radius: 4px;
  }

  .sidebar-content::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(90deg, #1FD4B5, #22C4B7);
  }

  /* Asegura que los íconos no se descuadren al colapsar */
  .custom-sidebar .sidebar-brand-narrow {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-sidebar .sidebar-brand-full {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .styled-heading { 
    font-family: 'Arial', sans-serif; 
    font-size: 1vw; 
    font-weight: bold; 
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1); 
    letter-spacing: 2px; 
    text-align: center; 
  } 
  
  .hide-on-unfold {
      display: none !important;
  }

  /* Opcional: Asegurar que el título no tiene margen cuando está plegado (para mejor alineación) */
  .c-sidebar-unfoldable .styled-heading {
      margin-top: 0 !important;
      display: none !important; /* Alternativa si no usas Vuex: usar el selector de CoreUI */
  }

  /* Ajuste para el estilo del nombre en el footer cuando está plegado */
  .c-sidebar-unfoldable .c-sidebar-footer div {
      justify-content: center; /* Centrar el avatar/icono cuando el texto se oculta */
  }

  .icon-sidebar-toggler {
    margin-left: 30px;
    width: 15px !important;
    margin-top: -5px;
  }
  .input-search-bar{
    width: 100%;
    cursor: text;
  }
  .input-search-bar:hover{
   background-color: #ebedef;
  }
</style>